import React from 'react';

const DailyAverages = ({ data }) => {
    if (!data) return null;

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Daily Averages</h6>
                <div className="row text-center g-2">
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Avg Revenue/Day</small>
                            <strong>{data.avg_daily_revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Avg Orders/Day</small>
                            <strong>{data.avg_daily_orders}</strong>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Avg Pieces/Day</small>
                            <strong>{data.avg_daily_pieces?.toLocaleString(undefined, { minimumFractionDigits: 1 })}</strong>
                        </div>
                    </div>
                    <div className="col-6 mt-2">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Active Days</small>
                            <strong>{data.active_days}</strong>
                        </div>
                    </div>
                    <div className="col-6 mt-2">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Rev/Active Day</small>
                            <strong>{data.avg_revenue_per_active_day?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                        </div>
                    </div>
                </div>
                {data.best_day && (
                    <div className="mt-2 text-center" style={{ fontSize: '0.8rem' }}>
                        <span className="text-success">Best: Day {data.best_day.day} ({data.best_day.revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })})</span>
                        <span className="mx-2">|</span>
                        <span className="text-danger">Worst: Day {data.worst_day?.day} ({data.worst_day?.revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })})</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DailyAverages;
